module.exports = __webpack_public_path__ + "img/add.85c502e5.png";